module.exports = __webpack_public_path__ + "img/40_38_080_450.2851fd87.jpg";